import { Button, Card } from 'react-bootstrap'
import AppLoader from 'components/general/AppLoader';
import { toast } from 'react-toastify'
import { useSelector } from "react-redux"
import { useState } from 'react'

export default function DeleteCard({ event, getEvents, showDeleteButton = false, onDelete, onCancel }) {
  const { user: authUser } = useSelector(x => x.auth)
  const url = process.env.REACT_APP_URL

  const [saveLoading, setSaveLoading] = useState(false)
  const [showCard, setShowCard] = useState(false)

  const handleShowCard = () => setShowCard(true)
  const handleCloseCard = () => {
    setShowCard(false)
    if (onCancel) onCancel()
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSaveLoading(true)
    try {
      const response = await fetch(`${url}/agendaEvent/${event._id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authUser.token}`
        },
      })
      if (response.status === 200) {
        getEvents() // Refresh the event list
        setShowCard(false)
        if (onDelete) onDelete() // Notify parent component
      } else {
        console.error(response)
        toast.error(`Failed to delete event ${event.name}`, { position: 'bottom-left' })
      }
    } catch (error) {
      console.error(error)
      toast.error(`Failed to delete event ${event.name}`, { position: 'bottom-left' })
    } finally {
      setSaveLoading(false)
    }
  }

  return (
    <>
      {showDeleteButton && !showCard ? (
        <Button
          variant="danger"
          className='mb-1 float-end'
          onClick={handleShowCard}
        >
          Delete Event
        </Button>
      ) : (
        showCard && (
          <Card className="text-center mt-2" data-bs-theme={'dark'}>
            <Card.Header>
              <Card.Title>
                Delete Event: <br /> {event.name}
              </Card.Title>
            </Card.Header>
            <Card.Body>
              Are you sure you want to delete this Event?
            </Card.Body>
            <Card.Footer>
              {saveLoading
                ? (
                  <>
                    <AppLoader />
                    Deleting Event ...
                  </>
                ) : (
                  <>
                    <Button variant="danger" type='submit' onClick={handleSubmit}>
                      Delete Event
                    </Button>
                    <Button variant="dark" onClick={handleCloseCard}>
                      Cancel
                    </Button>
                  </>
                )}
            </Card.Footer>
          </Card>
        )
      )}
    </>
  )
}
